module.exports = __webpack_public_path__ + "static/media/familyfeud.ac698fd1.jpg";